var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 0.421875C17.8137 0.421875 20.5 3.10817 20.5 6.42188V14.4219C20.5 17.7356 17.8137 20.4219 14.5 20.4219H6.5C3.18629 20.4219 0.5 17.7356 0.5 14.4219V6.42188C0.5 3.10817 3.18629 0.421875 6.5 0.421875H14.5ZM6.5 13.1055V14.9053H14.5V13.1055H6.5ZM7 6.42188C6.58333 6.42188 6.22917 6.56771 5.9375 6.85938C5.64583 7.15104 5.5 7.50521 5.5 7.92188C5.5 8.33854 5.64583 8.69271 5.9375 8.98438C6.22917 9.27604 6.58333 9.42188 7 9.42188C7.41667 9.42188 7.77083 9.27604 8.0625 8.98438C8.35417 8.69271 8.5 8.33854 8.5 7.92188C8.5 7.50521 8.35417 7.15104 8.0625 6.85938C7.77083 6.56771 7.41667 6.42188 7 6.42188ZM14 6.42188C13.5833 6.42188 13.2292 6.56771 12.9375 6.85938C12.6458 7.15104 12.5 7.50521 12.5 7.92188C12.5 8.33854 12.6458 8.69271 12.9375 8.98438C13.2292 9.27604 13.5833 9.42188 14 9.42188C14.4167 9.42188 14.7708 9.27604 15.0625 8.98438C15.3542 8.69271 15.5 8.33854 15.5 7.92188C15.5 7.50521 15.3542 7.15104 15.0625 6.85938C14.7708 6.56771 14.4167 6.42188 14 6.42188Z",
    fill: "#FDC913"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.c78f1dea215c69d6dcc1d3060f2a37dd.svg";
export { ForwardRef as ReactComponent };